import { render, staticRenderFns } from "./ColorDialog.vue?vue&type=template&id=73934c3c"
import script from "./ColorDialog.vue?vue&type=script&lang=js"
export * from "./ColorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports